import snickers from "../../images/jpgImages/image-product-1.jpg";
import snickers2 from "../../images/jpgImages/image-product-2.jpg";
import snickers3 from "../../images/jpgImages/image-product-3.jpg";
import snickers4 from "../../images/jpgImages/image-product-4.jpg";

export const data = [
  {
    fall: {
      image: [snickers, snickers2, snickers3, snickers4],
      alt: "snickers",
      subTitle: "sneaker company",
      title: "Fall Limited Edition  Sneakers",
      description:
        " These low-profile sneakers are your perfect casual wear companion. Featuring a durable rubber outer sole, they’ll withstand everything the weather can offer.",
      discountPrice: 125.0,
      discount: "50%",
      price: "$250.00",
    },
  },
];
